angular.module('customMasks', [])
  .directive('numericMask', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) { // Note: scope, attrs are needed by angular (do not remove)
        let prevValue = '';
        const formatter = scope.$parent.$parent.$ctrl.token._formatter;

        // Formatter function to update the view (Runs only on load?)
        ngModelCtrl.$formatters.push((value) => {
          if (!value) return value;
          prevValue = formatter.formatJsFloatStr(value);
          return prevValue;
        });
  
        // Parser function to update the model (returning same string for QB to work)
        ngModelCtrl.$parsers.push(value => value);
  
        element.on('input',  () => {
          const viewValue = element.val();
          if (viewValue) {
            const formattedValue = formatter.formatFloatStr(viewValue, prevValue);
            prevValue = formattedValue;
            ngModelCtrl.$setViewValue(formattedValue);
            ngModelCtrl.$render();
          }
        });
      }
    };
  });